export const buildEventHealthFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_name',
        label: 'VenueName',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(o => ({ value: o, label: o })),
      },
    ],
  },
  {
    id: 'event',
    label: 'Event',
    filters: [
      {
        id: 'event_name',
        label: 'EventName',
        type: 'search',
        options: (filterOptions.event_options || []).map(o => ({ value: o, label: o })),
      },
      {
        id: 'event_status',
        label: 'Status',
        type: 'checkbox',
        options: (filterOptions.status_options || []).map(o => ({ value: o.value, label: o.label })),
      },
      {
        id: 'presenter',
        label: 'Presenter',
        type: 'checkbox',
        options: (filterOptions.presenter_options || []).map(o => ({ value: o, label: o })),
      },
    ],
  },
  {
    id: 'tickets',
    label: 'Tickets',
    filters: [
      {
        id: 'capacity',
        label: 'Capacity',
        type: 'range',
        min: 0,
        max: filterOptions.max_capacity || 10000,
      },
      {
        id: 'ticket_count',
        label: 'Tickets Sold',
        type: 'range',
        min: 0,
        max: filterOptions.max_ticket_count || 10000,
      },
      {
        id: 'ticket_forecast',
        label: 'Forecast',
        type: 'range',
        min: 0,
        max: filterOptions.max_forecast || 10000,
      },
    ],
  },
  {
    id: 'velocity',
    label: 'Sales Velocity',
    filters: [
      {
        id: 'sold_today',
        label: 'Sold Today',
        type: 'range',
        min: 0,
        max: filterOptions.max_sold_today || 500,
      },
      {
        id: 'recent_7day',
        label: 'Last 7 Days',
        type: 'range',
        min: 0,
        max: filterOptions.max_recent_7day || 1000,
      },
    ],
  },
  {
    id: 'financials',
    label: 'Financials',
    filters: [
      {
        id: 'tickets_gross',
        label: 'Tickets Gross',
        type: 'range',
        min: 0,
        max: filterOptions.max_tickets_gross || 100000,
      },
      {
        id: 'profit_loss',
        label: 'P&L',
        type: 'range',
        min: filterOptions.min_profit_loss || -50000,
        max: filterOptions.max_profit_loss || 100000,
      },
    ],
  },
];
